import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled beyond 300px and not at bottom
  const toggleVisibility = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset;
    
    // Show only when scrolled down AND not at bottom
    const isScrolledDown = scrollTop > 300;
    const isNotAtBottom = scrollTop + windowHeight < documentHeight - 100;
    
    setIsVisible(isScrolledDown && isNotAtBottom);
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 rounded-lg flex items-center justify-center h-12 w-12 bg-red-600 hover:bg-red-700 text-white shadow-lg transition-colors duration-300"
          aria-label="Scroll to top"
        >
          <ChevronUp size={28} />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;